import React from 'react';
import { Button, Box, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import { ArrowForwardTwoTone } from '@mui/icons-material';
import PropTypes from 'prop-types';

const MyButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.grey[500],
  color: theme.palette.common.white,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1, 2),
  border: 'none',
  position: 'relative',
  overflow: 'hidden',
  transition: 'background-color 0.4s ease',
  '&::before, &::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    bottom: 0,
    width: '100%',
    backgroundColor: alpha(theme.palette.common.white, 0.3),
    transition: 'transform 0.4s ease',
  },

  '&::before': {
    left: '100%',
    transform: 'translateX(0)',
  },

  '&::after': {
    right: '100%',
    transform: 'translateX(0)',
  },

  '&:hover': {
    backgroundColor: theme.palette.grey[700],

    '&::before': {
      transform: 'translateX(-100%)',
    },

    '&::after': {
      transform: 'translateX(100%)',
    },

    '& .MuiTypography-root': {
      transition: 'transform 0.3s ease',
      transform: 'scale(1.05)',
    },
  },
}));

const CustomButton = ({ children, ...props }) => (
  <MyButton {...props} sx={{ height: 50 }}>
    <Box display="flex" alignItems="right">
      <Typography display="flex" alignItems="right">
        <Box>{children}</Box>
        <ArrowForwardTwoTone sx={{ ml: 2 }} />
      </Typography>
    </Box>
  </MyButton>
);

export default CustomButton;

CustomButton.propTypes = {
  children: PropTypes.node.isRequired,
};
